import { GridColumns, GridColumnVisibilityModel } from '@mui/x-data-grid';

export const columns: GridColumns = [
  {
    field: '__check__',
    headerName: 'common.commonProperties.boxSelection',
    maxWidth: 80,
    minWidth: 40,
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    sortable: false
  },
  {
    field: 'id',
    headerName: 'problems.statusFlows.columns.id',
    flex: 1,
    maxWidth: 70,
    minWidth: 40,
    headerAlign: 'center',
    align: 'center'
  },
  {
    field: 'name',
    headerName: 'problems.statusFlows.columns.name',
    flex: 1,
    minWidth: 150,
    headerAlign: 'center',
    align: 'center'
  },
  {
    field: 'clientName',
    headerName: 'problems.statusFlows.columns.clientName',
    flex: 1,
    minWidth: 150,
    headerAlign: 'center',
    align: 'center'
  },
  {
    field: 'enabled',
    headerName: 'common.commonProperties.status',
    flex: 1,
    maxWidth: 100,
    minWidth: 80,
    headerAlign: 'center',
    align: 'center'
    // renderCell se maneja automáticamente por genericTranslationColumns
  }
];

export const columnVisibilityModel: GridColumnVisibilityModel = {
  // obligatorias
  id: true,
  name: true,
  enabled: true
};

export const headerToExport: { label: string; key: string }[] = [
  { label: 'problems.statusFlows.columns.id', key: 'id' },
  { label: 'problems.statusFlows.columns.name', key: 'name' },
  { label: 'problems.statusFlows.columns.clientName', key: 'clientName' },
  { label: 'common.commonProperties.status', key: 'enabled' }
];
